import axios from "axios";

const state = {};

const getters = {};

const actions = {
  searchUserListByName({ commit }, { query, noPage, itemsPerPage }) {
    return new Promise((resolve, reject) => {
      axios({
        url:
          "/searchUserListByName?query=" +
          query +
          "&noPage=" +
          noPage +
          "&itemsPerPage=" +
          itemsPerPage,
        method: "get",
        baseURL: process.env.VUE_APP_BACKEND_URL,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  registerOrUpdateUser({ commit }, { user, photo }) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      let x;
      for (x in user) {
        bodyFormData.append(x, user[x]);
      }
      if (photo) {
        bodyFormData.append("photo", photo);
      }
      const url =
        "/" + (user.id === undefined ? "registerUser" : "users/" + user.id);
      axios({
        url,
        method: "post",
        baseURL: process.env.VUE_APP_BACKEND_URL,
        data: bodyFormData,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
